import {
  LOAD_OUTLINE, LOAD_PDF_FAILED, LOADED_PDF, LOADING_PDF, LOADED_PDF_OBJECT_URL,
} from './types';
import { appendDocumentTitle } from './window';
import { trackAdobeEvent } from '../../client/utils/trackers/adobe';

export async function loadOutline(pdfDocument, dispatch) {
  const outline = await pdfDocument.getOutline();
  if (outline && outline.length) {
    dispatch({ type: LOAD_OUTLINE, payload: outline });
  }
}

export async function loadTitle(pdfDocument) {
  const metadata = await pdfDocument.getMetadata();
  if (metadata && metadata.info && metadata.info.Title) {
    appendDocumentTitle(metadata.info.Title);
  }
}

export default function loadPdf() {
  return async (dispatch) => {
    dispatch({ type: LOADING_PDF });
    try {
      const { pdfDocument, pdfObjectUrl } = await window.loadingPdfPromise;

      dispatch({ type: LOADED_PDF, payload: pdfDocument });
      if (pdfObjectUrl) {
        dispatch({ type: LOADED_PDF_OBJECT_URL, payload: pdfObjectUrl });
      }
      return pdfDocument;
    } catch (e) {
      trackAdobeEvent('newPage', {
        form: {
          errorType: `ae-something went wrong...:${e.message}`,
        },
      });

      // eslint-disable-next-line no-console
      (console.error || console.log)(e);
      dispatch({ type: LOAD_PDF_FAILED });
      return null;
    }
  };
}
